import React, { Fragment, useMemo, useState } from "react"
import { Checkbox, FormControlLabel, Grid2 as Grid } from "@mui/material"
import { InterestsHeader } from "./InterestsHeader"
import { CheckSquare, Square } from "@phosphor-icons/react";
import { useCategories } from "../../../../hooks/apiHooks/useCategories";
import { COLLAB_INTEREST_NSFW, COLLAB_INTEREST_SFW, CONTENT_INTEREST_NSFW, CONTENT_INTEREST_SFW, NSFW_KEY, SFW_KEY } from "../../../../enums/generalEnums";
import { addRemoveArray } from "../../../../helpers/arrayHelper";

export const Interests = (props) => {
  const {
    collabInterestSelectedIds,
    contentInterestSelectedIds,
    sectionValidations,
    collabTitle = 'Collab Interest',
    contentTitle = 'Content Interest',
    setCollabInterestSelectedIds,
    setContentInterestSelectedIds,
    storeKey = 'id',
    separateCategory = false,
    isTitleVisible,
    visibility = {
      collab: true,
      content: true
    }
  } = props;

  const { data: categories } = useCategories({ type: [COLLAB_INTEREST_SFW, COLLAB_INTEREST_NSFW, CONTENT_INTEREST_NSFW, CONTENT_INTEREST_SFW] });
  const [isCollabInterestSFW, setIsCollabInterestSFW] = useState(false);
  const [isContentInterestSFW, setIsContentInterestSFW] = useState(false);

  const handleSelectInterests = (id, isAdd = true, isCollab = true) => {
    if (separateCategory) {
      if (isCollab) {
        setCollabInterestSelectedIds((prev) => {
          const key = isCollabInterestSFW ? NSFW_KEY : SFW_KEY;
          const list = (key === SFW_KEY) ? (prev.sfw ?? []) : (prev.nsfw ?? []);
          return { ...prev, [key]: addRemoveArray(list ?? [], isAdd, id) }
        });
      } else {
        setContentInterestSelectedIds((prev) => {
          const key = isContentInterestSFW ? NSFW_KEY : SFW_KEY;
          const list = (key === SFW_KEY) ? (prev.sfw ?? []) : (prev.nsfw ?? []);
          return { ...prev, [key]: addRemoveArray(list ?? [], isAdd, id) }
        });
      }
    } else {
      if (isCollab) {
        setCollabInterestSelectedIds((prev) => addRemoveArray(prev, isAdd, id));
      } else {
        setContentInterestSelectedIds((prev) => addRemoveArray(prev, isAdd, id));
      }
    }
  };

  const interests = useMemo(() => {
    const filterCategories = (type) => categories?.filter((item) => item?.type === type);
    return {
      collab: {
        [SFW_KEY]: filterCategories(COLLAB_INTEREST_SFW),
        [NSFW_KEY]: filterCategories(COLLAB_INTEREST_NSFW)
      },
      content: {
        [SFW_KEY]: filterCategories(CONTENT_INTEREST_SFW),
        [NSFW_KEY]: filterCategories(CONTENT_INTEREST_NSFW)
      }
    }
  }, [categories])

  const { collab, content } = interests;

  const tags = useMemo(() => ({
    collab: isCollabInterestSFW ? collab?.nsfw : collab?.sfw,
    content: isContentInterestSFW ? content?.nsfw : content?.sfw
  }), [collab, content, isCollabInterestSFW, isContentInterestSFW]);

  return (
    <Fragment>
      {
        visibility?.collab && <Fragment>
          <InterestsHeader
            isTitleVisible={isTitleVisible}
            title={collabTitle}
            validation={sectionValidations?.includes('collab') && 'Select atleast 3 collab interests'}
            isSFW={isCollabInterestSFW}
            handleToggleCollabInterestType={() => setIsCollabInterestSFW((prev) => !prev)}
          />
          <Grid container>
            {
              tags?.collab?.map((collabTag, index) => {
                const collabType = isCollabInterestSFW ? (collabInterestSelectedIds?.nsfw ?? []) : (collabInterestSelectedIds?.sfw ?? []);
                const renderList = separateCategory ? collabType : collabInterestSelectedIds;
                const isSelected = renderList?.includes(collabTag?.[storeKey]);
                return (
                  <Grid key={`tag-key-${index}`} item size={{ xs: 12, sm: 3 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isSelected}
                          icon={<Square size={24} color="#919EAB" />}
                          checkedIcon={<CheckSquare size={24} weight="fill" />}
                          onChange={(event) => handleSelectInterests(collabTag?.[storeKey], event.target.checked)}
                        />
                      }
                      label={collabTag?.name}
                    />
                  </Grid>
                )
              })
            }
          </Grid>
        </Fragment>
      }
      {
        visibility?.content && <Fragment>
          <InterestsHeader
            isTitleVisible={isTitleVisible}
            mt={2}
            title={contentTitle}
            validation={sectionValidations?.includes('content') && 'Select atleast 3 content interests'}
            isSFW={isContentInterestSFW}
            handleToggleCollabInterestType={() => setIsContentInterestSFW((prev) => !prev)}
          />
          <Grid container>
            {
              tags?.content?.map((contentTag, index) => {
                const collabType = isContentInterestSFW ? (contentInterestSelectedIds?.nsfw ?? []) : (contentInterestSelectedIds?.sfw ?? []);
                const renderList = separateCategory ? collabType : contentInterestSelectedIds;
                const isSelected = renderList?.includes(contentTag?.[storeKey]);
                return (
                  <Grid key={`tag-key-${index}`} item size={{ xs: 12, sm: 3 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isSelected}
                          icon={<Square size={24} color="#919EAB" />}
                          checkedIcon={<CheckSquare size={24} weight="fill" />}
                          onChange={(event) => handleSelectInterests(contentTag?.[storeKey], event.target.checked, false)}
                        />
                      }
                      label={contentTag?.name}
                    />
                  </Grid>
                )
              })
            }
          </Grid>
        </Fragment>
      }
    </Fragment>
  )
}